import React from 'react';
import { Link } from 'react-router-dom';
import _ from 'lodash';

import Utr from '../../text/Utr';
import BackgroundImage from '../../BackgroundImage';
import Img from '../../Img';
import Scores from './Scores';

import { drawPositionTypeIds } from '../../../utils/eventConstants';
import { titleCase } from '../../../utils/formatting';
import { getFlagUrl, getPlayerName, playerTypes, wonGame } from '../../../utils';

import styles from './flexleaguematchcard.scss';
import { OutComeTypes } from '../../../utils/postScoreConstants';

const getPlayers = (players, position, isPlayer, isTeam) => {
    let player; let team;
    if (position) {
        if (isPlayer) {
            player = _.find(players, { memberId: position.memberId });
            return [player];
        }
        if (isTeam) {
            team = players.filter(p => position.memberIds.includes(p.memberId));
            return team;
        }
    }
};

const TeamCard = props => {
    const { position, seed, players, user, result, gameType, utrType, sportTypeId, 'data-testid': dataTestId } = props;
    const { outcome, completionType } = result || {};

    const isPlayer = position?.typeId === drawPositionTypeIds.PLAYER;
    const isTeam = position?.typeId === drawPositionTypeIds.TEAM;
    let player1; let player2; let lookupMemberId;

    const showMatchWinner = () => {
        // Winner triangles should not be shown for incomplete and tie matches
        return !(outcome === 'incomplete' || completionType === 'tieincomplete' || completionType === 'tiecompleted' || outcome === OutComeTypes.ABANDONED || outcome === OutComeTypes.DOUBLEWALKOVER);
    };

    const getEmptyScores = () => {
        const scoreArray = ['-', '-', '-'];
        if (scoreArray.length > 0) {
            return (
                <>
                    {scoreArray.map((scoreItem, i) => {
                        return (
                            <div
                                className={`score-item`}
                                key={`score-item-${i}`}
                                data-testid={dataTestId && `${dataTestId}.score-${i}`}
                            >
                                {scoreItem}
                            </div>
                        );
                    })}
                </>
            );
        }
    };

    // Get Players Names from PlayerDictionary
    if (position) {
        if (isPlayer) {
            [player1] = getPlayers(players, position, isPlayer, isTeam);
            lookupMemberId = position.memberId;
        }
        if (isTeam) {
            [player1, player2] = getPlayers(players, position, isPlayer, isTeam);
            [lookupMemberId] = position.memberIds;
        }
    }
    const lookupPlayerId = _.find(players, { memberId: lookupMemberId })?.playerId;
    const showDecimalsP1 = user?.isPowered || (player1.playerId === user?.claimedPlayer?.playerId.toString() && player1.playerId === lookupPlayerId.toString());
    const winnerObject = result && wonGame(result.players, lookupPlayerId);
    return (
        <div className="team">
            <span className="seed" data-testid={dataTestId && `${dataTestId}.seed`}>
                {seed}
            </span>
            <div className="flex-column player-details-container ml0">
                {!player2 && (
                    <div className={`player-details ${styles.overflow}`}>
                        {!!player1.clubProfileImages && (
                            <BackgroundImage
                                baseUrl={'/v1/club/'}
                                defaultImage={'/img/utr-ball--teal.svg'}
                                images={player1.clubProfileImages}
                                imageType={'thumbnail'}
                                parentStylesClass={'flag-container club-profile-image'}
                            />
                        )}
                        {!player1.clubProfileImages && (
                            <span className="flag-container">
                                {player1.nationality && (
                                    <Img
                                        src={getFlagUrl(player1.nationality)}
                                        className="flag"
                                        alt={player1.nationality}
                                    />
                                )}
                            </span>
                        )}
                        <div className={`d-flex flex-column justify-content-start align-items-start player-name ${styles.name} ${showMatchWinner() ? winnerObject ? 'winner' : '' : ''}`}>
                            <Link to={`/profiles/${player1.playerId}`} className={styles.link} data-testid={dataTestId && `${dataTestId}.player-${player1.playerId}.link`}>
                                <div className="d-flex flex-row align-items-baseline">
                                    <div className="p0 mb0 name-wrapper show-ellipsis" data-testid={dataTestId && `${dataTestId}.player-${player1.playerId}.name`}>
                                        {titleCase(getPlayerName(player1.firstName, player1.lastName, true))}
                                    </div>
                                    <div className="utr-container">
                                        <Utr
                                            pbrClass={styles.pbr}
                                            player={player1}
                                            force={{ ratingType: gameType, utrType, showDecimals: showDecimalsP1 }}
                                            sportTypeId={sportTypeId}
                                        />
                                    </div>
                                </div>
                            </Link>
                        </div>
                    </div>
                )}
                {player1 && player2 && (
                    <div className={`player-details ${styles.overflow}`}>
                        {!!player1.clubProfileImages && (
                            <BackgroundImage
                                baseUrl={'/v1/club/'}
                                defaultImage={'/img/utr-ball--teal.svg'}
                                images={player1.clubProfileImages}
                                imageType={'thumbnail'}
                                parentStylesClass={'flag-container club-profile-image'}
                            />
                        )}
                        <div className="d-flex flex-column">
                            <div className="d-flex flex-row align-items-baseline">
                                {!player1.clubProfileImages && (
                                    <span className="flag-container">
                                        {player1.nationality && (
                                            <Img
                                                src={getFlagUrl(player1.nationality)}
                                                className="flag"
                                                alt={player1.nationality}
                                            />
                                        )}
                                    </span>
                                )}
                                <div className={`d-flex flex-column justify-content-start align-items-start player-name ${styles.name} ${showMatchWinner() ? winnerObject ? 'winner' : '' : ''}`}>
                                    <Link to={`/profiles/${player1.playerId}`} className={styles.link} data-testid={dataTestId && `${dataTestId}.player-${player1.playerId}.link`}>
                                        <div className="d-flex flex-row align-items-baseline">
                                            <div className="p0 mb0 name-wrapper show-ellipsis" data-testid={dataTestId && `${dataTestId}.player-${player1.playerId}.name`}>
                                                {titleCase(getPlayerName(player1.firstName, player1.lastName, true))}
                                            </div>
                                            <div className="utr-container">
                                                <Utr
                                                    pbrClass={styles.pbr}
                                                    player={player1}
                                                    force={{ ratingType: gameType, utrType, showDecimals: showDecimalsP1 }}
                                                    sportTypeId={sportTypeId}
                                                />
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            </div>
                            <div className="d-flex flex-row align-items-baseline">
                                {!player2.clubProfileImages && (
                                    <span className="flag-container">
                                        {player2.nationality && (
                                            <Img
                                                src={getFlagUrl(player2.nationality)}
                                                className="flag"
                                                alt={player2.nationality}
                                            />
                                        )}
                                    </span>
                                )}
                                <div className={`d-flex flex-column justify-content-start align-items-start player-name ${styles.name} ${showMatchWinner() ? winnerObject ? 'winner' : '' : ''}`}>
                                    <Link to={`/profiles/${player2.playerId}`} className={styles.link} data-testid={dataTestId && `${dataTestId}.player-${player2.playerId}.link`}>
                                        <div className="d-flex flex-row align-items-baseline">
                                            <div className="p0 mb0 name-wrapper show-ellipsis" data-testid={dataTestId && `${dataTestId}.player-${player2.playerId}.name`}>
                                                {titleCase(getPlayerName(player2.firstName, player2.lastName, true))}
                                            </div>
                                            <div className="utr-container">
                                                <Utr
                                                    pbrClass={styles.pbr}
                                                    player={player2}
                                                    force={{ ratingType: gameType, utrType, showDecimals: showDecimalsP1 }}
                                                    sportTypeId={sportTypeId}
                                                />
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
            {result ? (
                <>
                    <div className="d-flex flex-row aic scores-container">
                        <Scores
                            score={result.score}
                            playerType={winnerObject ? playerTypes.WINNER : playerTypes.LOSER}
                            showMatchWinner={showMatchWinner}
                            outcome={outcome}
                            completionType={completionType}
                            result={result}
                            data-testid={dataTestId && `${dataTestId}.scores`}
                        />
                    </div>
                    <div className="d-flex flex-column jcc winner-display-container">
                        {winnerObject && showMatchWinner(outcome, completionType) && (
                            <div className="winning-scores" />
                        )}
                    </div>
                </>
            ) : (
                getEmptyScores()
            )}
        </div>
    );
};

TeamCard.defaultProps = {
    'data-testid': null,
};

export default TeamCard;
